module.exports = __webpack_public_path__ + "images/img4.png";